import { Box, Grid, styled, Typography } from '@mui/material';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
  padding: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-left: 2px solid var(--divider, rgba(0, 0, 0, 0.12));
`;

export const AssemblyPreviewTitleContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AssemblyPreviewContainer = styled(Grid)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.brand.whitesmoke,
  border: `1px solid ${theme.palette.brand.disable}`,
  borderRadius: '4px',
  height: '350px',
  overflow: 'hidden',
}));

export const CardInfoTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 500;
  overflow-wrap: anywhere;
  width: 100%;
`;
export const StyledChipContainer = styled(Box)`
  margin: 5px 5px 5px 0;
  display: inline-block;
`;

export const StyledDynamicTooltipChip = styled(DynamicTooltipChip)`
  max-width: 272px;
`;

export const CardInfoDescription = styled(Box)`
  display: flex;
  justify-content: space-between;
`;
